export { default } from './AlertTitle';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/lab/esm/AlertTitle/index.js
// module id = 881
// module chunks = 2